
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/allgames",
      function () {
        return require("private-next-pages/allgames/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/allgames"])
      });
    }
  